module.exports = __webpack_public_path__ + "static/media/avare.1aca7c35.jpeg";